/**
 * 引入vue及vuex
 */
import Vue from 'vue'
import Vuex from 'vuex'
import userinfo from './modules/userinfo'
import index from './modules/index'

Vue.use(Vuex)

/**
 * 输出
 */
export default new Vuex.Store({
  modules: {
    userinfo,
    index
  }
})